/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../../../../nls/StringResources',
	'react',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit',
	'@ba/ba-graphics/dist/icons-js/reset_32'
], function (_, stringResources, React, PropTypes, Toolkit, reset32) {

	const reset = reset32.default;

	const {
		Button
	} = Toolkit;

	class ButtonFooterSection extends React.Component {
		static propTypes = {
			clearPossible: PropTypes.bool.isRequired,
			onClear: PropTypes.func.isRequired
		};

		render() {
			return (
				<div className="buttonFooterSection" style={{ 'textAlign': 'right' }}>
					<Button
						label={stringResources.get('topbottomClearLabel')}
						icon={reset.id}
						intent="primary"
						variant="frameless"
						disabled={!this.props.clearPossible}
						onClick={this.props.onClear}
					/>
				</div>
			);
		}
	}

	return ButtonFooterSection;
});
